<template>
  <div>
    <overwatchLoader id='loader' v-if='!site'/>
    <model path="/static/novotel/novotelRatesHorizontalV2/" :content="model" :format='1610'></model>
    <div id='novotelRatesHorizontalV2' class='d-flex flex-column justify-content-around' v-if='site'>
      <div id='master' class='d-flex flex-column justify-content-center align-items-center'>
        <div class="titleBloc d-flex flex-row justify-content-start align-items-center">
          <div class="title">{{ $tlang(lg1, 'novotel.rates.roomRatesTitle') }}*</div>
          <div class="subtitle">{{ $tlang(lg2, 'novotel.rates.roomRatesTitle') }}*</div>
        </div>
        <div id="dateHour" class='d-flex flex-column justify-content-center align-items-end'>
          <div id="date">{{ date }}</div>
          <div id="hour">{{ hour}}</div>
        </div>
        <div id='main' class='d-flex flex-row justify-content-between'>
          <rates class='left' :ratesLg='ratesServicesLeft'></rates>
          <rates class='right' :ratesLg='ratesServicesRight'></rates>
        </div>
        <div id="additionalServices" v-if="additionalServices" class="d-flex justify-content-start align-items-center">
          <div class="lg1" v-html="additionalServices.lg1.label_value"></div>
          <div class="lg2" v-html="additionalServices.lg2.label_value"></div>
        </div>
        <div id="legalNotice">
          <div v-for="(notice, index) in legalNoticeLgLeft.lg1" :key="notice">
            <span class="lg1" v-if="notice.ta_value" v-html="notice.ta_value"></span> 
            <span class="lg2" v-if="legalNoticeLgLeft.lg2[index]" v-html="legalNoticeLgLeft.lg2[index].ta_value"></span> 
          </div>
          <div v-for="(notice, index) in legalNoticeLgCenter.lg1" :key="notice">
            <span class="lg1" v-if="notice.ta_value" v-html="notice.ta_value"></span> 
            <span class="lg2" v-if="legalNoticeLgLeft.lg2[index]" v-html="legalNoticeLgLeft.lg2[index].ta_value"></span> 
          </div>
        </div>
        <svg id="logo_n" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340"><defs></defs><path class="cls-1" d="M24,97.17C134.08,104.87,207.47,70.68,270.84,10,223.4,94,122.09,124,24,97.17"/><path class="cls-1" d="M215.53,281.54c-40.1,0-65.51-63.55-89.86-84.84v84.84H103.3V165.19h9.13c33.65,0,63.18,66.94,89.67,88.42V165.19h22.38V281.54Z"/><rect class="cls-2" width="340" height="340"/></svg>
      </div>
    </div>
  </div>
</template>

<script>
import Titles from './titles'
import Rates from './rates/rates'
import OverwatchLoader from '../../../../loader/overwatch'
import model from '../../../../debug/model'
import moment from 'moment'

export default {
  name: 'novotelRatesHorizontalV2',
  components: {
    pageTitles: Titles,
    rates: Rates,
    OverwatchLoader,
    model,
  },
  data: function () {
    return {
      rightOrder: ['change', 'hosts', 'messages'],
      model: [],
      rightIndex: -1,
      msgCurrentPage: 1,
      goNextComponent: true,
      date: '',
      hour: ''
    }
  },
  mounted () {
    this.$dm.getData(this.$route) // get data on start
    this.refreshDate()
  },
  computed: {
    ratesLg () {
      let rates = this.site && this.site.get('rates')
      if (rates) {
        let data = rates.get('data')
        if (data) {
          return {
            lg1: data[data.languages[0].id],
            lg2: data[data.languages[1].id]
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    /*
    filteredServices: function () { // remove additional services if necessary
      if (this.ratesLg.lg1.settings.additional_services === '1') {
        return { lg1: this.ratesLg.lg1.otherServices.regular.slice(0, -1), lg2: this.ratesLg.lg2.otherServices.regular.slice(0, -1) }
      } else {
        return { lg1: this.ratesLg.lg1.otherServices.regular, lg2: this.ratesLg.lg2.otherServices.regular }
      }
    },
    */
    ratesLG1 () {
      return this.ratesLg.lg1.rates2;
    },
    ratesLG1Length () {
      return Object.keys(this.ratesLG1).length;
    },
    servicesLeftLG1 () {
      return  this.ratesLg.lg1.otherServices.regular;
    },
    servicesLeftLG1Length () {
      const len = Object.keys(this.servicesLeftLG1).length;
      if (this.ratesLg.lg1.settings.additional_services === '1') {
        return len - 1;
      } else {
        return len;
      }
    },
    servicesRightLG1 () {
      return  this.ratesLg.lg1.otherServices.right;
    },
    servicesRightLG1Length () {
      return Object.keys(this.servicesRightLG1).length;
    },
    ratesServices () {
      let ratesServices = [];
      const count = Math.min(10, this.ratesLG1Length + this.servicesLeftLG1Length + this.servicesRightLG1Length);
      for (let i = 0; i < this.ratesLG1Length; i++) {
        if (ratesServices.length < count) {
          ratesServices.push({ type: "rate", lg1:  this.ratesLG1[i + 1], lg2: this.ratesLg.lg2.rates2[i + 1] })
        }
      }
      for (let i = 0; i < this.servicesLeftLG1Length; i++) {
        if (ratesServices.length < count) {
          ratesServices.push({ type: "service", lg1:  this.servicesLeftLG1[i], lg2: this.ratesLg.lg2.otherServices.regular[i] })
        }
      }
      for (let i = 0; i < this.servicesRightLG1Length; i++) {
        if (ratesServices.length < count) {
          ratesServices.push({ type: "service", lg1:  this.servicesRightLG1[i], lg2: this.ratesLg.lg2.otherServices.right[i] })
        }
      }
      return ratesServices;
    },
    ratesServicesLeft () {
        return this.ratesServices.slice(0, Math.ceil(this.ratesServices.length / 2));
    },
    ratesServicesRight () {
        return this.ratesServices.slice(-Math.floor(this.ratesServices.length / 2));
    },
    changeLg () {
      let change = this.site && this.site.get('change')
      if (change) {
        let data = change.get('data')
        if (data) {
          return {
            lg1: data[data.languages[0].id].exchangeRate,
            lg2: data[data.languages[1].id].exchangeRate
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    messages () {
      try {
        return this.site && this.site.get('messages').get('data')
      } catch (error) {
        return null
      }
    },
    netStatus () {
      return this.$store.state.connected
    },
    site () {
      let site = this.$store.getters.site
      console.log('site()', site)
      return site
    },
    user () {
      return this.$store.getters.user
    },
    device () {
      return this.$store.getters.device
    },
    rightStatus () {
      return this.rightOrder[this.rightIndex]
    },
    siteName () {
      try {
        return this.site.get('rates').get('data').siteName
      } catch (e) {
        return ''
      }
    },
    page () {
      return this.$route.query.page
    },
    transitionName () {
      if (this.page) {
        return 'off' // no transition if page is forced
      } else {
        return 'fade'
      }
    },
    additionalServices: function () {
      if (this.ratesLg.lg1.settings.additional_services === '1') {
        let regularLg1 = this.ratesLg.lg1.otherServices.regular
        let regularLg2 = this.ratesLg.lg2.otherServices.regular
        return { lg1: regularLg1[regularLg1.length - 1], lg2: regularLg2[regularLg2.length - 1] }
      } else {
        return null
      }
    },
    lg1 () {
      return this.$store.getters.site.get('rates').get('data').languages[0].name.toLowerCase()
    },
    lg2 () {
      return this.$store.getters.site.get('rates').get('data').languages[1].name.toLowerCase()
    },
    legalNoticeLgLeft () {
      return {lg1: this.ratesLg.lg1.subtitles['1'], lg2: this.ratesLg.lg2.subtitles['1']}
    },
    legalNoticeLgCenter () {
      if (this.ratesLg) {
        return {lg1: this.ratesLg.lg1.subtitles['2'], lg2: this.ratesLg.lg2.subtitles['2']}
      } else {
        return null
      }
    },
  },
  watch: {
    netStatus (newStatus, oldStatus) {
      console.log('netStatus update', oldStatus, newStatus)
      // Get data on connection status change
      if (oldStatus) { // getData must not be done the first time
        console.log('netStatus getdata')
        this.$dm.getData(this.$route)
      }
    },
    user (newUser, oldUser) {
      console.log('User update', oldUser, newUser)
      // Get data when user is logged
      if (oldUser && newUser) {
        console.log('user getdata')
        this.$dm.getData(this.$route)
      }
    },
    device (newDevice, oldDevice) {
      console.log('Device update', oldDevice, newDevice)
      // refresh data on device update
      if (oldDevice && oldDevice._objCount && newDevice) {
        console.log('device getdata')
        this.$dm.getData(this.$route)
      }
    },
    site (newSite, oldSite) {
      console.log('Site updated', oldSite, newSite)
    }
  },
  methods: {
    alternates () {
      if (this.page) { // for test purpose
        this.rightIndex = this.page
      } else {
        let display =
          (this.changeLg && this.changeLg.lg1.rates.length) ||
          (this.ratesLg && this.ratesLg.lg1.inCharge.length) ||
          (this.messages && this.messages.clients_messages.length)
        if (!display) {
          setTimeout(this.alternates, 1000)
          return
        }
        if (this.goNextComponent) {
          this.rightIndex++
        }
        if (this.rightIndex >= this.rightOrder.length) {
          this.rightIndex = 0
        }
      }
      let len = 0
      switch (this.rightStatus) {
        case 'change':
          this.goNextComponent = true
          len = this.changeLg && this.changeLg.lg1.rates.length
          if (!len) {
            this.alternates()
            return
          }
          break
        case 'hosts':
          this.goNextComponent = true
          if (this.ratesLg) {
            len = this.ratesLg && this.ratesLg.lg1.inCharge.length
          }
          if (!len) {
            this.alternates()
            return
          }
          break
        case 'messages':
          this.goNextComponent = true
          len = this.messages && this.messages.clients_messages.length
          if (!len) {
            this.alternates()
            return
          }
          if (this.$refs.messages.nextPage()) {
            this.goNextComponent = false
          }
          break
      }
      setTimeout(this.alternates, 7000)
    },
    refreshDate () {
      moment.locale('fr')
      this.date = moment().format('L')
      this.hour = moment().format('LT')
      setTimeout(this.refreshDate, 60000)
    },
  }
}
</script>

<style lang='scss' scoped>
$srcWidth : 1920;
$srcHeight : 1200;
@import "../../../_novotel.scss";

#novotelRatesHorizontalV2 {
  width: 160vh; // https://www.alsacreations.com/article/lire/1490-comprendre-le-viewport-dans-le-web-mobile.html
  height: 100vh;
  background-color: white;
  
  #master {
    // position: absolute;
    // width: 160vh;
    // height: 100vh;

    .titleBloc {
        font-family: "Montserrat-Regular";
        @include widthPercent(1804);

        .title {
            @include fontSize(57);
            color: $grey;
          
            &::first-letter {
              text-transform: uppercase;
            }
        }

        .subtitle {
            @include fontSize(57);
            color: $lightGrey;

            &::first-letter {
              text-transform: uppercase;
            }

            margin-left: 20px;
        }
    }

    #dateHour {
      position : absolute;
      right: 60px;
      @include topPercent(47);
      font-family: "Montserrat-Medium";
      @include fontSize(25);
      color: $lightGrey;
    }


    #main {
      @include widthPercent(1804);

      .left {
        @include widthPercent(940);
        padding-top: 40px;
      }

      .right {
        @include widthPercent(814);
        padding-top: 40px;
      }
    }

    #additionalServices {
      font-family: "Montserrat-Regular";
      @include widthPercent(1804);
      @include heightPercent(106);
      border-top : 1px solid $grey;
      border-bottom : 1px solid $grey;
    }

    #legalNotice {
      font-family: "Montserrat-Regular";
      @include widthPercent(1804);
      padding-right: 160px;
      padding-top: 10px;
      div {
        display: inline;

        & + div {
          padding-left: 10px;
        }
      }
    }

    #logo_n {
       @include widthPercent(170);
       @include heightPercent(170);
       position : absolute;
       right: 0px;
       bottom: 25px;
       .cls-1{fill:#29398e;}
       .cls-2{fill:none;}
    }
  }
}

</style>

<style lang='scss'>
$srcWidth : 1920;
$srcHeight : 1200;
@import "../../../_novotel.scss";
@import "../../../../../../scss/global.scss";

#app {
  @extend .gradientBackground;
}

.lg1 {
  color: $grey;
}

.lg2 {
  color: $lightGrey;
}

#novotelRatesHorizontalV2 {
  .additional_services {

    p {
      display: inline-block;
      margin: 0;

      &::first-letter {
        text-transform: uppercase;
      }
      margin-right: 10px;

      &:nth-of-type(1) {
        @include fontSize(36);
      }

       &:nth-of-type(2) {
        @include fontSize(30);
        &::before {
          content: " - ";
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/novotel/rates/horizontal/v2/novotelRatesHorizontalV2.vue